import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BuyerPayment, usersAPIs } from "../../Components/constants/constants";

const token = localStorage.getItem("token");
const headers = {
  headers: {
    authorization: token,
  },
};

export const getUsersList = createAsyncThunk("getUsersList", async (role) => {
  let response;
  try {
    response = await axios.get(usersAPIs[role].getList(), headers);
  } catch (error) {
    console.log(error);
    return [];
  }
  return response.data.data;
});

export const getUserbyId = createAsyncThunk("getUserbyId", async (id) => {
  let response;
  try {
    response = await axios.get(usersAPIs.getUserDetails(id), headers);
  } catch (error) {
    console.log(error);
    return null;
  }
  console.log("response",response.data)
  return response.data;
});

export const getEvaluatorLeadList = createAsyncThunk(
  "getEvaluatorLeadList",
  async (id) => {
    try {
      const response = await axios.get(
        usersAPIs.getEvaluatorLeads(id),
        headers
      );
      return response.data.data;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
);


// Define the initial state for the slice
const initialState = {
  listByRole: [],
  selectedUser: {},
  status: "",
  error: "",
  evaluatorLeadList: [],
  verfiedEvaluators: [],
  BuyerPayment:[],
};

const AllUsersSlice = createSlice({
  name: "allUser",
  initialState,
  reducers: {
    clearKycUserid: (state) => {
      state.KycUserid = {}; // Clear the KYC data for a specific user
    },
    setVerifiedEvaluators: (state, action) => {
      console.log("iss data therem ver", state.Users);
      state.verfiedEvaluators = action.payload.filter(
        (evaluator) => evaluator.aadharverification == true && evaluator?.panverification == true 
      );
    },
  },
  extraReducers(builder) {
    // get Users List
    builder
      .addCase(getUsersList.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(getUsersList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.listByRole = action.payload;
      })
      .addCase(getUsersList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      // Get Evaluator Lead List
      .addCase(getEvaluatorLeadList.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(getEvaluatorLeadList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.evaluatorLeadList = action.payload;
      })
      .addCase(getEvaluatorLeadList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      //Get user By ID
      .addCase(getUserbyId.pending, (state, action) => {
        state.status = "loading";
      })
      .addCase(getUserbyId.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.selectedUser = action.payload;
      })
      .addCase(getUserbyId.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })

      

      
  },
});

export const { clearKycUserid, setVerifiedEvaluators } = AllUsersSlice.actions;

export default AllUsersSlice.reducer;
